import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const PHOTOS = [
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/a865868d-d9df-4c45-8453-95cdd0b15b6d_Quantum-Electrical-Services-Sleaford---Tesla-EV-Charger-Installation.jpg?v=916cc30bfa4bcbb570ebda20fce9c671',
    alt: 'Tesla EV Charger Installation by Quantum Electrical Services Sleaford',
    label: 'EV Charger Installation',
    span: 'col-span-2',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/768ce801-92ef-4295-91bc-91337e52d47d_Quantum-Electrical-Services-Sleaford---Consumer-Unit-Upgrade.jpg?v=fc2730dcac9bcfdbedb280779424b26b',
    alt: 'Consumer Unit Upgrade by Quantum Electrical Services Sleaford',
    label: 'Consumer Unit Upgrade',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/146b2ce1-f879-42f3-b61e-3406b406df2e_Solar-Panel-Installation-in-Sleaford-by-Quantum-Electrical-Services02.jpeg?v=a73be763a43c6bdec85f0a8ccb45e430',
    alt: 'Solar Panel Installation in Sleaford by Quantum Electrical Services',
    label: 'Solar Installation',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/1015436f-88fd-4b86-9ff3-e5cf601d97c7_WhatsApp-Image-2024-07-15-at-20.35.33-1.jpeg?v=152047022aaf1df65e06446757116b09',
    alt: 'Electrical installation work by Quantum Electrical Services',
    label: 'Electrical Installation',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/2a8f07b0-e688-4691-b4c8-3cf3dff19c1a_WhatsApp-Image-2024-07-15-at-20.35.32.jpeg?v=6eb9dbad91db3baa2d43deae3174642c',
    alt: 'Professional electrical work completed in Lincolnshire',
    label: 'Wiring & Circuits',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/a2dea59d-8479-4b80-9d82-3f44ea0fd246_WhatsApp-Image-2024-07-15-at-20.35.33.jpeg?v=4d7155cd8db3735b23251d002696e335',
    alt: 'Quality electrical work by Quantum Electrical Sleaford',
    label: 'Electrical Work',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/22f350dc-f784-4e6d-a116-dfbad1f9391d_WhatsApp-Image-2024-07-15-at-20.35.37-3.jpeg?v=3619e5983fd688e821dd228d5db22979',
    alt: 'Certified electrical installation Sleaford Lincolnshire',
    label: 'Certified Install',
    span: 'col-span-1',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/11a69976-9566-4b83-9a69-a93eee5056c5_unnamed.jpg?v=36c8eeaa415e16c187349526f8f1bd2a',
    alt: 'Electrical services completed by Quantum Electrical Services',
    label: 'Electrical Services',
    span: 'col-span-1',
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState<null | (typeof PHOTOS)[0]>(null);
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();

  return (
    <section id="gallery" className="py-24 bg-[#0D1E35] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headRef as React.RefObject<HTMLDivElement>}
          className={`flex flex-col md:flex-row items-start md:items-end justify-between mb-12 gap-4 transition-all duration-700 ${
            headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div>
            <p className="text-[#C8A96A] text-xs tracking-widest uppercase font-medium mb-3">Our Work</p>
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-white leading-tight">
              Work That Speaks{' '}
              <span className="bg-gradient-to-r from-[#C8A96A] to-[#E0C78A] bg-clip-text text-transparent">
                For Itself
              </span>
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-xs text-right hidden md:block">
            Every job completed to the highest standard, fully certified and documented.
          </p>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PHOTOS.map((photo, i) => (
            <GalleryItem key={i} photo={photo} index={i} onClick={() => setLightbox(photo)} />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-6"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center text-white/70 hover:text-[#C8A96A] text-2xl cursor-pointer transition-colors"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line" />
          </button>
          <img
            src={lightbox.src}
            alt={lightbox.alt}
            className="max-w-full max-h-[85vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 text-sm bg-white/10 px-4 py-2 rounded-full">
            {lightbox.label}
          </p>
        </div>
      )}
    </section>
  );
}

function GalleryItem({
  photo,
  index,
  onClick,
}: {
  photo: (typeof PHOTOS)[0];
  index: number;
  onClick: () => void;
}) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      onClick={onClick}
      className={`group relative overflow-hidden rounded-2xl cursor-pointer transition-all duration-700 ${
        isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
      } ${photo.span === 'col-span-2' ? 'lg:col-span-2' : ''}`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <img
        src={photo.src}
        alt={photo.alt}
        className="w-full h-56 object-cover object-top group-hover:scale-110 transition-transform duration-700"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
          <span className="text-white font-semibold text-sm">{photo.label}</span>
          <div className="w-8 h-8 flex items-center justify-center bg-[#C8A96A] rounded-full text-black">
            <i className="ri-zoom-in-line text-sm" />
          </div>
        </div>
      </div>
      {/* Gold border on hover */}
      <div className="absolute inset-0 border-2 border-[#C8A96A] rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </div>
  );
}
